
document.addEventListener('DOMContentLoaded', function () {
  function initVariantAndSwiper() {
    const section = document.querySelector('.selected-product-section');
    if (!section) return;

    const product = window.currentProduct || {};
    const variantMeta = window.variantMeta || {};
    const priceEl = section.querySelector('#variant-price');
    const viewLink = section.querySelector('#view-variant-link');

    let mainSwiperInstance = null;
    let thumbSwiperInstance = null;
    const colorOptionIndex = 0;

    function readImagesFromProduct() {
      const images = [];
      if (product.media && Array.isArray(product.media)) {
        product.media.forEach(m => {
          const src = m.preview_image?.src || m.image?.src || m.src || '';
          const alt = m.alt || m.image?.alt || '';
          if (src) images.push({ src, alt });
        });
      } else if (product.images && Array.isArray(product.images)) {
        product.images.forEach(img => {
          if (typeof img === 'string') images.push({ src: img, alt: '' });
          else images.push({ src: img.src || '', alt: img.alt || '' });
        });
      }
      return images;
    }

    function getSelectedOptions() {
      const groups = section.querySelectorAll('.variant-option-group');
      return Array.from(groups).map(g => {
        const activeBtn = g.querySelector('.variant-button.active');
        return activeBtn ? activeBtn.getAttribute('data-value') : null;
      });
    }

    function findVariantByOptions(selectedOptions) {
      if (!product.variants) return null;
      return product.variants.find(v => {
        if (Array.isArray(v.options)) return v.options.every((opt, i) => opt === selectedOptions[i]);
        if (selectedOptions.length === 1 && v.option1) return v.option1 === selectedOptions[0];
        if (selectedOptions.length === 2 && v.option1 && v.option2) return v.option1 === selectedOptions[0] && v.option2 === selectedOptions[1];
        if (selectedOptions.length === 3 && v.option1 && v.option2 && v.option3) return v.option1 === selectedOptions[0] && v.option2 === selectedOptions[1] && v.option3 === selectedOptions[2];
        return false;
      }) || null;
    }
    
    // Check if any variant exists with the given partial options (null values are ignored)
    function hasVariantWithOptions(testOptions) {
      if (!product.variants) return false;
      return product.variants.some(v => {
        // Check each option position - if testOptions[i] is not null, it must match
        for (let i = 0; i < testOptions.length; i++) {
          if (testOptions[i] !== null && testOptions[i] !== undefined) {
            let variantOption = null;
            if (Array.isArray(v.options)) {
              variantOption = v.options[i];
            } else {
              if (i === 0) variantOption = v.option1;
              else if (i === 1) variantOption = v.option2;
              else if (i === 2) variantOption = v.option3;
            }
            if (variantOption !== testOptions[i]) {
              return false;
            }
          }
        }
        return true;
      });
    }

    function buildSlidesHtml(images) {
      return images.map(img => `<div class="swiper-slide"><img src="${img.src}" alt="${img.alt}" ></div>`).join('');
    }

    function destroySwipers() {
      if (mainSwiperInstance?.destroy) mainSwiperInstance.destroy(true, true);
      if (thumbSwiperInstance?.destroy) thumbSwiperInstance.destroy(true, true);
    }

    function updateVariantButtonStates() {
      const selectedOptions = getSelectedOptions();
      const groups = section.querySelectorAll('.variant-option-group');
      
      groups.forEach((group, groupIndex) => {
        const buttons = group.querySelectorAll('.variant-button');
        
        buttons.forEach(btn => {
          const btnValue = btn.getAttribute('data-value');
          const testOptions = [...selectedOptions];
          testOptions[groupIndex] = btnValue;
          
          // Check if any variant exists with this combination (partial match is OK)
          const hasVariant = hasVariantWithOptions(testOptions);
          
          if (hasVariant) {
            // Check if at least one variant with this combination is available
            const availableVariant = product.variants.find(v => {
              for (let i = 0; i < testOptions.length; i++) {
                if (testOptions[i] !== null && testOptions[i] !== undefined) {
                  let variantOption = null;
                  if (Array.isArray(v.options)) {
                    variantOption = v.options[i];
                  } else {
                    if (i === 0) variantOption = v.option1;
                    else if (i === 1) variantOption = v.option2;
                    else if (i === 2) variantOption = v.option3;
                  }
                  if (variantOption !== testOptions[i]) {
                    return false;
                  }
                }
              }
              return true;
            });
            
            if (availableVariant && availableVariant.available) {
              btn.classList.remove('disabled');
              btn.removeAttribute('disabled');
            } else {
              btn.classList.add('disabled');
            }
          } else {
            btn.classList.add('disabled');
            // Don't set disabled attribute - keep it clickable for visual indication only
          }
        });
      });
    }

    function updateUIForVariant() {
      const selectedOptions = getSelectedOptions();
      const variant = findVariantByOptions(selectedOptions);

      // Update disabled states of variant buttons
      updateVariantButtonStates();

      if (variant) {
        const vm = variantMeta[String(variant.id)] || {};
        if (priceEl) priceEl.textContent = vm.formatted_price || '';
        if (viewLink) viewLink.href = vm.url || `${product.url}?variant=${variant.id}`;
      }

      const images = readImagesFromProduct();
      const color = selectedOptions[colorOptionIndex]?.toLowerCase().trim() || '';
      let matched = images.filter(img => img.alt?.toLowerCase().trim() === color);
      if (matched.length === 0 && color) matched = images.filter(img => img.alt?.toLowerCase().includes(color));
      const slidesToUse = matched.length > 0 ? matched : images;

      const mainWrapper = section.querySelector('.mySwiper .swiper-wrapper');
      const thumbWrapper = section.querySelector('.mySwiper2 .swiper-wrapper');
      if (!mainWrapper || !thumbWrapper) return;

      mainWrapper.innerHTML = buildSlidesHtml(slidesToUse);
      thumbWrapper.innerHTML = buildSlidesHtml(slidesToUse);

      destroySwipers();

      thumbSwiperInstance = new Swiper('.mySwiper2', {
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: { nextEl: '.thumb-next', prevEl: '.thumb-prev' },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: false,
        }
      });

      // Update carousel slide ARIA (aria-hidden, aria-label) for accessibility
    function updateCarouselSlideAria(swiper) {
      if (!swiper || !swiper.slides || !swiper.slides.length) return;
      const total = swiper.slides.length;
      const activeIndex = swiper.realIndex != null ? swiper.realIndex : swiper.activeIndex;
      swiper.slides.forEach((slide, i) => {
        const isActive = i === activeIndex;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + total);
      });
    }

    mainSwiperInstance = new Swiper('.mySwiper', {
        spaceBetween: 10,
        navigation: { nextEl: '.main-next', prevEl: '.main-prev' },
        thumbs: { swiper: thumbSwiperInstance },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: false,
        },
        on: {
          init: function () {
            setProductGalleryNavAriaLabels(section);
            setTimeout(function () { setProductGalleryNavAriaLabels(section); }, 0);
            updateCarouselSlideAria(this);
          },
          slideChange: function () {
            updateCarouselSlideAria(this);
          }
        }
      });
      setProductGalleryNavAriaLabels(section);
      ensureWidthPreselected();
    }

    function setProductGalleryNavAriaLabels(container) {
      const prevBtn = container.querySelector('.main-prev');
      const nextBtn = container.querySelector('.main-next');
      if (prevBtn) prevBtn.setAttribute('aria-label', 'Previous image');
      if (nextBtn) nextBtn.setAttribute('aria-label', 'Next image');
    }

    // Show popup message for missing selections (only once per product per validation attempt)
    function showSelectionPopup(productSection) {
      // Use data attribute to track if popup was shown for this product
      const popupShown = productSection.getAttribute('data-popup-shown');
      if (popupShown === 'true') {
        return;
      }
      
      productSection.setAttribute('data-popup-shown', 'true');
      
      // Show modal instead of alert
      if (window.SelectionRequiredModal && typeof window.SelectionRequiredModal.open === 'function') {
        window.SelectionRequiredModal.open();
        
        // Reset flag after modal is closed
        const modal = document.querySelector('.pahi-selection-modal');
        if (modal) {
          // Wait for modal close animation
          setTimeout(() => {
            productSection.removeAttribute('data-popup-shown');
          }, 500);
        }
      } else {
        // Fallback to alert if modal is not available
        alert('Please select size before adding to cart.');
        setTimeout(() => {
          productSection.removeAttribute('data-popup-shown');
        }, 100);
      }
    }
    
    // Bind form submissions to validate selections
    const addToCartForms = section.querySelectorAll('.add-to-cart-form');
    addToCartForms.forEach(form => {
      form.addEventListener('submit', (e) => {
        // Find the product section that contains this form
        const productSection = form.closest('.selected-product-section');
        
        // Find the variant selectors container that contains this form
        const variantSelectors = productSection?.querySelector('.variant-selectors');
        if (!variantSelectors) {
          // Fallback to section if variant-selectors not found
          variantSelectors = section.querySelector('.variant-selectors');
        }
        
        if (!variantSelectors) {
          return;
        }
        
        // Re-query groups for this specific product section
        const currentGroups = variantSelectors.querySelectorAll('.variant-option-group');
        
        // Filter out groups with data-option-index="0" (Gender/Color)
        const groupsToCheck = Array.from(currentGroups).filter(group => {
          const optionIndex = group.getAttribute('data-option-index');
          return optionIndex !== '0';
        });
        
        // Check if all required groups have an active selection
        const allSelected = groupsToCheck.length === 0 || groupsToCheck.every(group => {
          const buttons = group.querySelectorAll('.variant-button');
          if (buttons.length === 0) return true;
          return Array.from(buttons).some(btn => btn.classList.contains('active'));
        });
        
        if (!allSelected) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation(); // Prevent other handlers
          if (productSection) {
            showSelectionPopup(productSection);
          } else {
            showSelectionPopup(section);
          }
          return false;
        }
      }, true); // Use capture phase to handle early
    });

    function bindVariantButtons() {
      const groups = section.querySelectorAll('.variant-option-group');
      groups.forEach(group => {
        const buttons = group.querySelectorAll('.variant-button');
        buttons.forEach(btn => {
          btn.addEventListener('click', () => {
            // Remove active class from all buttons in this group
            buttons.forEach(b => b.classList.remove('active'));
            // Add active class to clicked button
            btn.classList.add('active');
            updateUIForVariant();
          });
        });
      });
    }

    // Ensure Width option always has first available value selected (after init, tab change, or any UI update)
    function ensureWidthPreselected() {
      const groups = section.querySelectorAll('.variant-option-group');
      groups.forEach(group => {
        const label = group.querySelector('.vareint-title-product');
        const labelText = (label && label.textContent || '').toLowerCase();
        if (labelText.indexOf('width') === -1) return;
        const allInGroup = group.querySelectorAll('.variant-button');
        if (allInGroup.length === 0) return;
        const firstNonDisabled = group.querySelector('.variant-button:not(.disabled)');
        const targetBtn = firstNonDisabled || allInGroup[0];
        allInGroup.forEach(b => b.classList.remove('active'));
        targetBtn.classList.add('active');
      });
    }

    bindVariantButtons();
    ensureWidthPreselected();
    updateUIForVariant();
    ensureWidthPreselected();
  }

  // --- FUNCTION: Attach Male/Female buttons ---
  function attachGenderButtons() {
    const sectionEl = document.querySelector('.selected-product-section');
    if (!sectionEl) return;

    const buttons = sectionEl.querySelectorAll('button[product-url]');
    buttons.forEach(btn => {
      btn.addEventListener('click', async function (e) {
        e.preventDefault();
        const url = btn.getAttribute('product-url');
        if (!url) return;

        try {
          const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!res.ok) throw new Error('Network error');

          const html = await res.text();

          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newSection = doc.querySelector('.selected-product-section');

          if (newSection) {
            sectionEl.replaceWith(newSection);

            const scriptTag = newSection.querySelector('script');
            if (scriptTag) {
              try { eval(scriptTag.innerText); } 
              catch (err) { console.warn('Failed to eval product JSON script', err); }
            }

            initVariantAndSwiper();
            attachGenderButtons();
          }

        } catch (err) {
          console.error(err);
        } finally {
          sectionEl.style.opacity = '1';
        }
      });
    });
  }
  initVariantAndSwiper();
  attachGenderButtons();
});